"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolveVersion(envPrefix) {
    const env = process.env;
    function resolve(key) {
        const keyWithPrefix = `${envPrefix}${key}`;
        const value = env[keyWithPrefix];
        return value;
    }
    const dateString = resolve('RELEASE_DATE');
    const version = {
        git: {
            hash: resolve('GIT_HASH') || '',
            branch: resolve('GIT_BRANCH') || '',
            tag: resolve('GIT_TAG') || ''
        },
        package: {
            version: resolve('PACKAGE_VERSION') || '',
            name: resolve('PACKAGE_NAME') || '',
        },
        date: dateString ? new Date(dateString) : null,
        release: resolve('RELEASE_NAME') || ''
    };
    return version;
}
exports.resolveVersion = resolveVersion;
function resolveVersionFromJSON(jsonString) {
    if (!jsonString) {
        return defaultVersionInfo();
    }
    try {
        const parsed = JSON.parse(jsonString);
        parsed.date = parsed.date ? new Date(parsed.date) : null;
        return parsed;
    }
    catch (err) {
        console.error('Could not parse version info', jsonString);
        return defaultVersionInfo();
    }
}
exports.resolveVersionFromJSON = resolveVersionFromJSON;
function defaultVersionInfo() {
    return {
        git: {
            branch: '',
            hash: '',
            tag: ''
        },
        package: {
            version: '',
            name: ''
        },
        date: null,
        release: ''
    };
}
//# sourceMappingURL=version-info.js.map